<div *ngIf="showComponent" class="rs-maxh rs-padding-bottom2" data-cy="nortonFamilySection">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col">
    <h3 class="rs-tit6">{{ 'norton.familyPremier.title' | translate }}</h3>
    <p>
      <a
        href="{{ 'norton.familyPremier.installLink.url' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'norton.familyPremier.title' | translate }}"
        attr.data-tms-link-name="{{ 'norton.familyPremier.installLink.clickHere' | translate }} {{
          'norton.familyPremier.installLink.label' | translate
        }}"
        attr.data-tms-link-url="{{ 'norton.familyPremier.installLink.url' | translate }}"
      >
        {{ 'norton.familyPremier.installLink.clickHere' | translate }}</a
      >&nbsp;{{ 'norton.familyPremier.installLink.label' | translate }}
    </p>
    <p>
      <a
        href="{{ 'norton.familyPremier.manageLink.url' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'norton.familyPremier.title' | translate }}"
        attr.data-tms-link-name="{{ 'norton.familyPremier.manageLink.clickHere' | translate }} {{
          'norton.familyPremier.manageLink.label' | translate
        }}"
        attr.data-tms-link-url="{{ 'norton.familyPremier.manageLink.url' | translate }}"
      >
        {{ 'norton.familyPremier.manageLink.clickHere' | translate }}</a
      >&nbsp;{{ 'norton.familyPremier.manageLink.label' | translate }}
    </p>
    <div class="rs-me"></div>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <p>
        <a href="{{ 'norton.familyPremier.howToLink.url' | translate }}">{{
          'norton.familyPremier.howToLink.label' | translate
        }}</a>
      </p>
    </div>
  </div>
</div>
